<template>
    <div class="user-logins">
        <el-table
            :data="collection.data"
            style="width: 100%"
            v-loading="loading"
            fit
            ref="filterTable"
            row-key="id"
            border
            :row-class-name="tableRowClassName"
            default-expand-all
        >
            <el-table-column prop="ip_address" label="IP Address"></el-table-column>
            <el-table-column prop="login_at" align="center" label="Login"></el-table-column>
            <el-table-column header-align="center" label="Location"  width="400">
                <template slot-scope="scope">
                    <el-descriptions class="margin-top" :column="1" size="mini" border>
                        <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-location-outline"></i>
                                City
                            </template>
                            {{ _.get(scope.row.location, "city") }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-location-outline"></i>
                                State
                            </template>
                            {{ _.get(scope.row.location, "state") }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-location-outline"></i>
                                Postcode
                            </template>
                            {{ _.get(scope.row.location, "postal_code") }}
                        </el-descriptions-item>
                    </el-descriptions>
                </template>
            </el-table-column>
            <el-table-column align="center" label="Status">
                <template slot-scope="scope">
                    <el-tag size="mini" :type="scope.row.login_successful ? 'success' : 'danger'">
                        {{ scope.row.login_successful ? "Success" : "Failed" }}
                    </el-tag>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="collection.total > 0"
            :total="collection.total"
            :page.sync="collection.current_page"
            :limit.sync="collection.per_page"
            @pagination="getCollection"
        />
    </div>
</template>

<script>
    import Pagination from '@shared/components/pagination'
    export default {
        name: "userLogins",
    components: {
            Pagination
        },
        data() {
            return {
                collection: {},
                search: '',
                loading: true,
                listFilters: {
                    search: "",
                    ip: "",
                    user: ""
                },
                listLimit: 10,
            }
        },
        mounted() {
            this.listFilters.user = this.userProfile.id
            this.$tenant.get(`/api/settings/auth-logs`)
                .then((res) => {
                    this.setData(res, 'collection')
                }).catch(err => {
                    err.output()
                })

        },

        computed: {
            userProfile: {
                get() {
                    return this.$store.getters['user/user']
                },
                set(profile) {
                    this.$store.dispatch('user/setUser', profile)
                }
            },
        },

        methods: {
            setData(res, model) {
                this.$set(this.$data, model, res.data.collection)
                this.loading = false;
                this.$bar.finish()
            },
            clearFilter() {
                this.$refs.filterTable.clearFilter();
            },
            handleFilter(loading = false) {
                this.loading = loading;
                let collection = this.collection;
                let event = {
                    page: 1,
                    limit: collection.per_page
                }
                this.getCollection(event);
            },
            tableRowClassName({ row }) {
                if (_.get(row, 'blacklisted') == true) {
                    return 'danger-row';
                }
                return '';
            },
            getCollection(event) {
                this.$bar.start()
                this.$tenant.get(`/api/settings/auth-logs?page=${event.page}&per_page=${event.limit}&${this.$serialize(this.listFilters)}`)
                    .then(res => {
                        this.$set(this.$data, 'collection', res.data.collection)
                        this.loading = false;
                        this.$bar.finish()
                    }).catch(err => {
                        err.output()
                    })
            },
            handleActionButtonClick(e) {
                e.stopPropagation()
            }
        },
    }
</script>

<style lang="scss" scoped>
    .user-logins {
        padding: 50px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
</style>
